import Section from './section.view';

export default Section;
